import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { useHasPermissionWithLoading } from "../../hooks/useHasPermission";

export interface GuardedButtonProps extends Omit<ButtonProps, "action"> {
  feature: string;
  action: string;
  hideWhenDisabled?: boolean;
}

export const GuardedButton: React.FC<GuardedButtonProps> = ({
  feature,
  action,
  hideWhenDisabled = false,
  disabled,
  children,
  ...buttonProps
}) => {
  const { hasPermission, isLoading } = useHasPermissionWithLoading(feature, action);

  // Hide button if permission denied and hideWhenDisabled is true
  if (!hasPermission && hideWhenDisabled && !isLoading) {
    return null;
  }

  // Show button with loading indicator while permissions are loading
  // Don't disable during loading to provide better UX
  const isDisabled = isLoading ? false : (!hasPermission || disabled);

  return (
    <Button
      {...buttonProps}
      disabled={isDisabled}
      startIcon={isLoading ? <CircularProgress size={16} /> : buttonProps.startIcon}
    >
      {children}
    </Button>
  );
};
